import { render } from "./Signup.vue?vue&type=template&id=327f5bee&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=327f5bee&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327f5bee"]])

export default __exports__